<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageGenericPos.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageGenericPos.card.general')" cols="12 6@desktop">
        <!--        <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>-->
        <hm-card-inner>
          <hm-input-select :label="$t('admin.interfaces.pageGenericPos.posSystem')"
                           :value="posSystem"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="posSystem"
                           @input="onChangePosSystem"
                           @change="onChangePosSystem">
            <option v-for="it in posSystems" :value="it" v-html="it.name" />
          </hm-input-select>
          <template>
            <hm-input v-if="!isNil(posSystem) && posSystem.protectCompanyCode"
                      :label="$t('admin.interfaces.pageGenericPos.companyCode')"
                      :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                      :value="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') ? config.companyCode : config.companyCode.replace(/.(?=.{4,}$)/g, '*')"
                      cols="12 6@hd start-1"
                      name="companyCode" />
            <hm-input v-else-if="hasRole('ROLE_SYSADMIN')"
                      :label="$t('admin.interfaces.pageGenericPos.companyCode')"
                      v-model="config.companyCode"
                      cols="12 6@hd start-1"
                      name="companyCode" />
            <hm-input v-else
                      :disabled="true"
                      :label="$t('admin.interfaces.pageGenericPos.companyCode')"
                      :value="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') ? config.companyCode : config.companyCode.replace(/.(?=.{4,}$)/g, '*')"
                      cols="12 6@hd start-1"
                      name="companyCode" />
          </template>
          <hm-input :label="$t('admin.interfaces.pageGenericPos.label')"
                    v-model="config.label"
                    :disabled="disabledFields.includes('label')"
                    cols="12 6@hd start-1"
                    name="label" />
        </hm-card-inner>
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.postItemsIndividually')"
                           v-model="config.postItemsIndividually"
                           :disabled="disabledFields.includes('postItemsIndividually') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="postItemsIndividually" />
          <!-- required for Steingress -->
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.useGuestId')"
                           v-model="config.useGuestId"
                           :disabled="disabledFields.includes('useGuestId') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="useGuestId" />
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.hideDescription')"
                           v-model="config.hideDescription"
                           :disabled="disabledFields.includes('hideDescription')"
                           cols="12 6@hd start-1"
                           name="hideDescription" />
          <!-- required for Melzer -->
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.useNumericGuestId')"
                           v-model="config.useNumericGuestId"
                           :disabled="disabledFields.includes('useNumericGuestId') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="useNumericGuestId" />
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.provideFolios')"
                           v-model="config.provideFolios"
                           :disabled="disabledFields.includes('provideFolios') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="provideFolios" />
          <!-- may not be disabled for APRO, Steingress, Melzer -->
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.cacheDisabled')"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || ['apro', 'Steingress', 'MelzerX3000', 'rainmaker'].includes((posSystem || {}).name)"
                           v-model="config.cacheDisabled"
                           cols="12 6@hd start-1"
                           name="cacheDisabled" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageGenericPos.categoryMapping.mapping')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-input-select :label="$t('admin.interfaces.pageGenericPos.mappingType')"
                           v-model="config.mappingType"
                           :disabled="disabledFields.includes('mappingType') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           enum-name="PosMappingType"
                           name="mappingType" />
          <hm-input-select v-if="config.mappingType === 'Invoice'"
                           :label="$t('admin.interfaces.pageGenericPos.invoiceIhsId')"
                           v-model="config.invoiceIhsId"
                           :disabled="disabledFields.includes('invoiceIhsId')"
                           cols="12 6@hd start-1"
                           name="invoiceIhsId">
            <option :value="null"></option>
            <option v-for="item in hotelSettings.inHouseServices.all(config.invoiceIhsId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input-select :label="$t('admin.interfaces.pageGenericPos.tipIhsId')"
                           v-model="config.tipIhsId"
                           :disabled="disabledFields.includes('tipIhsId')"
                           cols="12 6@hd start-1"
                           name="tipIhsId">
            <option :value="null"></option>
            <option v-for="item in hotelSettings.inHouseServices.all(config.tipIhsId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
        </hm-card-inner>
        <hm-card-inner v-if="config.mappingType === 'VatRate'" :full-size="true">
          <hm-table :hover="false"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="1fr 2fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.vatMapping.vat') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.vatMapping.ihs') }}</div>
            </template>
            <template v-for="(vat, vatIdx) in config.vatRateToIhsId">
              <div class="hm-table__td">
                <hm-input-money :label="$t('admin.interfaces.pageGenericPos.vatMapping.vat')"
                                :digits="2"
                                :inline="true"
                                v-model="vat.key"
                                :id="`vat-${vatIdx}`"
                                currency="%"
                                name="vat" />
              </div>
              <div class="hm-table__td">
                <hm-input-select :label="$t('admin.interfaces.pageGenericPos.vatMapping.ihs')"
                                 :inline="true"
                                 v-model="vat.value"
                                 :id="`ihs-${vatIdx}`"
                                 name="ihs">
                  <option :value="null"></option>
                  <option v-for="item in hotelSettings.inHouseServices.all(vat.value)" :value="item.id" v-html="item.name[$shortLocale]"></option>
                </hm-input-select>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner v-if="config.mappingType === 'CategoryId'">
          <hm-table :hover="false"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="1fr 2fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.categoryMapping.category') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.categoryMapping.ihs') }}</div>
            </template>
            <template v-for="(category, categoryIdx) in config.categoryIdToIhsId">
              <div class="hm-table__td">
                <hm-input :label="$t('admin.interfaces.pageGenericPos.categoryMapping.category')"
                          :inline="true"
                          v-model="category.key"
                          :id="`category-${categoryIdx}`"
                          name="category" />
              </div>
              <div class="hm-table__td">
                <hm-input-select :label="$t('admin.interfaces.pageGenericPos.categoryMapping.ihs')"
                                 :inline="true"
                                 v-model="category.value"
                                 :id="`ihs-${categoryIdx}`"
                                 name="ihs">
                  <option :value="null"></option>
                  <option v-for="item in hotelSettings.inHouseServices.all(category.value)" :value="item.id" v-html="item.name[$shortLocale]"></option>
                </hm-input-select>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageGenericPos.categoryMapping.fakeReservations')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-table :hover="false"
                    :disable-scroll="true"
                    columns="2"
                    grid-template-columns="1fr 2fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.fakeReservations.roomNumber') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.fakeReservations.guestProfileId') }}</div>
            </template>
            <template v-for="(fakeReservation, fakeReservationIdx) in config.fakeReservationList">
              <div class="hm-table__td">
                <hm-input :label="$t('admin.interfaces.pageGenericPos.fakeReservations.roomNumber')"
                          :inline="true"
                          v-model="fakeReservation.roomNumber"
                          :id="`roomNumber-${fakeReservationIdx}`"
                          name="roomNumber" />
              </div>
              <div class="hm-table__td hm-table__td--overflow">
                <guest-search v-model="fakeReservation.guestProfileId"
                              :label="$t('admin.interfaces.pageGenericPos.fakeReservations.guestProfileId')"/>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { cloneDeep, first, isEmpty, isNil, last, sortBy } from 'lodash';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';
import GuestSearch from '../../../lib/inputs/GuestSearch';

export default {
  name: 'PageGenericPos',
  components: { GuestSearch, HmInputSelect, HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        cbSaveComplete();

        const toSave = cloneDeep(this.config);
        toSave.vatRateToIhsId = Object.fromEntries(toSave.vatRateToIhsId.filter(it => !isNil(it.key) && !isEmpty(it.value)).map(it => [it.key, it.value]));
        toSave.categoryIdToIhsId = Object.fromEntries(toSave.categoryIdToIhsId.filter(it => !isEmpty(it.key) && !isEmpty(it.value)).map(it => [it.key, it.value]));
        toSave.fakeReservationList = toSave.fakeReservationList.filter(it => !isEmpty(it.roomNumber));

        this.axios.put(this.serviceUrls.interfaces.genericPos.get(this), toSave)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      posSystem: null,
      posSystems: {
        userDefined: {
          name: this.$t('admin.interfaces.pageGenericPos.categoryMapping.userDefined'),
          data: {
          },
          companyCodes: [],
        },
        Adelsberger: {
          name: 'Adelsberger',
          data: {
            cacheDisabled: false,
          },
          companyCodes: ['d768MrwhwD65xfSpIcLtTMNG'],
          protectCompanyCode: true,
        },
        apro: {
          name: 'apro Kassensystem',
          data: {
            cacheDisabled: false,
          },
          companyCodes: ['q4Y7R3rpJsVSXCgTNsC4hRB4'],
          protectCompanyCode: true,
        },
        gastroAssistent: {
          name: 'gastroAssistent',
          data: {
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: false,
          },
          companyCodes: ['qX5nGw8vWfBqvrAFWZ9DbPYG'],
          protectCompanyCode: true,
        },
        hiopos: {
          name: 'HIOPOS',
          data: {
          },
          companyCodes: ['uZ8cpkWoMDH4MM0NvAw0ui9X'],
          protectCompanyCode: true,
        },
        MelzerX3000: {
          name: 'Melzer X3000',
          data: {
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: true,
          },
          companyCodes: ['z4mJT7UUCFzRfchhXA88WWRc'],
          protectCompanyCode: true,
        },
        rsPos: {
          name: '[rs]Pos',
          data: {
            postItemsIndividually: true,
            provideFolios: false,
            useNumericGuestId: false,
            cacheDisabled: true,
          },
          companyCodes: ['cbAQPrh1RVeJ6xJqNYu5ybb7'],
          protectCompanyCode: true,
        },
        Steingress: {
          name: 'Steingress Kassensysteme',
          data: {
            postItemsIndividually: true,
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: false,
          },
          companyCodes: ['95gKP6BMJrJYYApTk2XjNuS9', '7HgX4gC744hhXzZm6hwqNCeK'],
          protectCompanyCode: true,
        },
        Gastrotouch: {
          name: 'Gastrotouch',
          data: {
            postItemsIndividually: true,
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: true,
          },
          companyCodes: ['iSwCJZXxVSbivy4xvEdzFsMg'],
          protectCompanyCode: true,
        },
        woetzer: {
          name: 'Computerkassen Wötzer',
          data: {
            cacheDisabled: false,
          },
          companyCodes: ['2a46459f-f650-4fb0-9796-f92f7ae36dd3'],
          protectCompanyCode: true,
        },
        fersterer: {
          name: 'rainmaker',
          data: {
            postItemsIndividually: true,
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: true,
          },
          companyCodes: ['rGxvRw2bR3Lq2KbLvGcK2jDz'],
          protectCompanyCode: true,
        },
      },
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    disabledFields: function () {
      if (isNil(this.posSystem) || isNil(this.posSystem.data)) return [];
      else return Object.keys(this.posSystem.data);
    },
  },

  watch: {
    'config.vatRateToIhsId': {
      handler: function (newVal) {
        let ret = cloneDeep(newVal);

        const emptyRecords = ret.filter(it => isNil(it.key) && isEmpty(it.value)).length;
        const lastRecord = last(ret);

        if (emptyRecords > 1 || isNil(lastRecord) || !isNil(lastRecord.key) || !isEmpty(lastRecord.value)) {
          ret = ret.filter(it => !isNil(it.key) || !isEmpty(it.value));
          ret.push({ key: null, value: null });

          this.config.vatRateToIhsId = ret;
        } else if (emptyRecords === 0) {
          ret.push({ key: null, value: null });

          this.config.vatRateToIhsId = ret;
        }
      },
      deep: true,
    },
    'config.categoryIdToIhsId': {
      handler: function (newVal) {
        let ret = cloneDeep(newVal);

        const emptyRecords = ret.filter(it => isEmpty(it.key) && isEmpty(it.value)).length;
        const lastRecord = last(ret);

        if (emptyRecords > 1 || isNil(lastRecord) || !isEmpty(lastRecord.key) || !isEmpty(lastRecord.value)) {
          ret = ret.filter(it => !isEmpty(it.key) || !isEmpty(it.value));
          ret.push({ key: null, value: null });

          this.config.categoryIdToIhsId = ret;
        } else if (emptyRecords === 0) {
          ret.push({ key: null, value: null });

          this.config.categoryIdToIhsId = ret;
        }
      },
      deep: true,
    },
    'config.fakeReservationList': {
      handler: function (newVal) {
        let ret = cloneDeep(newVal);

        const emptyRecords = ret.filter(it => isEmpty(it.roomNumber) && isEmpty(it.guestProfileId)).length;
        const lastRecord = last(ret);

        if (emptyRecords > 1 || isNil(lastRecord) || !isEmpty(lastRecord.roomNumber) || !isEmpty(lastRecord.guestProfileId)) {
          ret = ret.filter(it => !isEmpty(it.roomNumber) || !isEmpty(it.guestProfileId));
          ret.push({ fakeNumber: null, roomNumber: null, guestProfileId: null });

          this.config.fakeReservationList = ret;
        } else if (emptyRecords === 0) {
          ret.push({ fakeNumber: null, roomNumber: null, guestProfileId: null });

          this.config.fakeReservationList = ret;
        }
      },
      deep: true,
    },
    'config.companyCode': {
      handler: function (newVal) {
        const posSystem = Object.values(this.posSystems)
          .find(it => it.companyCodes && it.companyCodes.includes(newVal));

        if (!isNil(posSystem) && !isNil(this.config)) {
          Object.entries(posSystem.data).forEach((it) => {
            this.config[it[0]] = it[1];
          });
        }

        this.posSystem = isNil(posSystem) ? this.posSystems.userDefined : posSystem;
      },
      deep: true,
    },
  },

  created: function () {
    this.posSystem = this.posSystems.userDefined;
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.genericPos.get(this))
        .then((response) => {
          const tmp = response.data.data;
          if (!isNil(tmp.vatRateToIhsId)) tmp.vatRateToIhsId = sortBy(Object.entries(tmp.vatRateToIhsId).map(it => ({ key: parseFloat(it[0]), value: it[1] })), 'key');
          if (!isNil(tmp.categoryIdToIhsId)) tmp.categoryIdToIhsId = sortBy(Object.entries(tmp.categoryIdToIhsId).map(it => ({ key: it[0], value: it[1] })), 'key');

          this.config = tmp;
        });
    },
    onChangePosSystem(posSystem) {
      if (isNil(posSystem)) {
        this.companyCode = null;
        this.posSystem = this.posSystems.userDefined;
        return;
      }

      if (!posSystem.companyCodes.includes(this.config.companyCode)) {
        this.config.companyCode = first(posSystem.companyCodes);
      }
      Object.entries(posSystem.data).forEach((it) => {
        this.config[it[0]] = it[1];
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageGenericPos.vue